import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClientSearchDialogComponent } from '@app/client/client-search-dialog/client-search-dialog.component';
import { AppComponentBase } from '@shared/app-component-base';
import { ClientDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.css']
})

export class SelectClientComponent extends AppComponentBase implements OnInit {

  @Input()
  text: string = this.l('SelectClient');

  private _selection: ClientDto = null;
  get selection(): ClientDto {
    return this._selection;
  }
  @Input()
  set selection(value: ClientDto) {
    if (this._selection === value) {
      return;
    }
    this._selection = value;
    this.selectionChange.emit(this._selection);
  }
  @Output() selectionChange = new EventEmitter<ClientDto>();

  constructor(injector: Injector,
    private _dialog: MatDialog) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onSearch() {
    let clientSearchDialog = this._dialog.open(ClientSearchDialogComponent);
    clientSearchDialog.componentInstance.selectedItem.subscribe(returnData => {
      this.selection = returnData;
    });
  }

  onClear() {
    this.selection = null;
  }

  // onSelectionChnaged() {
  //   this.selectionChange.emit(this.selection);
  // }
}
